import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/legal-layout";

export const Route = createFileRoute("/impressum")({
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" lastUpdated="December 24, 2025">
      <section className="space-y-6">
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Information according to § 5 DDG
          </h2>
          <p className="text-muted-foreground mb-6">
            In accordance with the German Digital Services Act
            (Digitale-Dienste-Gesetz, DDG), formerly known as Telemediengesetz
            (TMG), we provide the following information:
          </p>
        </div>

        <div className="bg-muted/50 border border-border rounded-2xl p-6 space-y-4">
          <div>
            <h3 className="font-semibold mb-2">Service Provider</h3>
            <p>
              <strong>Name:</strong> Harshil Agrawal
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Operating as: Images AI
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-2">Address</h3>
            <p>Helene-Jacobs-Str.</p>
            <p>14199 Berlin</p>
            <p>Germany</p>
          </div>

          <div>
            <h3 className="font-semibold mb-2">Contact Information</h3>
            <p>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:hey@harshil.dev"
                className="text-foreground hover:underline"
              >
                hey@harshil.dev
              </a>
            </p>
            <p className="text-xs text-muted-foreground mt-3">
              Please contact us via email for the fastest response.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-2">VAT Identification Number</h3>
            <p className="text-sm text-muted-foreground">
              Not VAT registered - Small business regulation according to § 19
              UStG (Kleinunternehmerregelung)
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-2">Responsible for Content</h3>
            <p>
              <strong>Name:</strong> Harshil Agrawal
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              According to § 18 Abs. 2 Medienstaatsvertrag (MStV)
            </p>
          </div>
        </div>
      </section>

      <section className="space-y-6 mt-12">
        <div>
          <h2 className="text-2xl font-semibold mb-4">EU Dispute Resolution</h2>
          <p className="text-muted-foreground leading-relaxed">
            The European Commission provides a platform for online dispute
            resolution (OS):{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground hover:underline"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            . You can find our email address in the impressum above.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Consumer Dispute Resolution
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            We are not willing or obliged to participate in dispute resolution
            proceedings before a consumer arbitration board.
          </p>
        </div>
      </section>

      <section className="space-y-6 mt-12">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Liability for Content</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            As a service provider, we are responsible for our own content on
            these pages in accordance with § 7 para. 1 DDG and general laws.
            According to §§ 8 to 10 DDG, however, we as a service provider are
            not obligated to monitor transmitted or stored third-party
            information or to investigate circumstances that indicate illegal
            activity.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Obligations to remove or block the use of information in accordance
            with general laws remain unaffected. However, liability in this
            regard is only possible from the time of knowledge of a specific
            legal violation. Upon becoming aware of such violations, we will
            remove this content immediately.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Liability for Links</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            Our website contains links to external third-party websites over
            whose content we have no influence. Therefore, we cannot assume any
            liability for this external content. The respective provider or
            operator of the pages is always responsible for the content of the
            linked pages.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            The linked pages were checked for possible legal violations at the
            time of linking. Illegal content was not recognizable at the time of
            linking. However, permanent monitoring of the content of the linked
            pages is not reasonable without concrete evidence of a legal
            violation. Upon becoming aware of legal violations, we will remove
            such links immediately.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold mb-4">Copyright</h2>
          <p className="text-muted-foreground leading-relaxed mb-4">
            The content and works created by the site operators on these pages
            are subject to German copyright law. The reproduction, editing,
            distribution, and any kind of use outside the limits of copyright
            law require the written consent of the respective author or creator.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Downloads and copies of this page are only permitted for private,
            non-commercial use. Insofar as the content on this page was not
            created by the operator, the copyrights of third parties are
            respected. In particular, third-party content is identified as such.
            Should you nevertheless become aware of a copyright infringement,
            please inform us accordingly. Upon becoming aware of legal
            violations, we will remove such content immediately.
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
